<script>
export default {
    name: 'IlluFonctionSupports',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-fonction-supports"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M52 32h-6.765c.476-.53-.235-1.231-.235-2a3 3 0 00-6 0c0 .769-.71 1.47-.235 2H32v-6.126a4 4 0 110-7.748V12h6.126a4 4 0 117.748 0H52v20z"
                :fill="primaryColor"
                class="primary-color"
            />
            <path
                d="M32.5 12.5h-19v6.337A3.482 3.482 0 0012 18.5c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 008.5 22c0 .966.392 1.841 1.025 2.475A3.489 3.489 0 0012 25.5c.537 0 1.046-.12 1.5-.337V31.5h6.337A3.482 3.482 0 0019.5 33c0 .966.392 1.841 1.025 2.475A3.489 3.489 0 0023 36.5c.966 0 1.841-.392 2.475-1.025A3.489 3.489 0 0026.5 33c0-.537-.12-1.045-.337-1.5H32.5v-6.337a3.486 3.486 0 01-1.5.337 3.489 3.489 0 01-2.475-1.025A3.489 3.489 0 0127.5 22c0-.966.392-1.841 1.025-2.475A3.489 3.489 0 0131 18.5c.537 0 1.046.121 1.5.337V12.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                d="M32.517 50.5l.2-6.011a3.492 3.492 0 002.82-1.077A3.488 3.488 0 0036.5 41c0-.966-.392-1.841-1.025-2.475a3.497 3.497 0 00-2.974-.99V31.5h-6.338c.216.455.337.963.337 1.5 0 .966-.392 1.841-1.025 2.475A3.489 3.489 0 0123 36.5a3.489 3.489 0 01-2.475-1.025A3.489 3.489 0 0119.5 33c0-.537.12-1.045.337-1.5H13.5v19h6.337A3.482 3.482 0 0019.5 52c0 .966.392 1.841 1.025 2.475A3.489 3.489 0 0023 55.5c.966 0 1.841-.392 2.475-1.025A3.489 3.489 0 0026.5 52c0-.537-.12-1.045-.337-1.5h6.354z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                d="M32.5 50.5h19.016l.2-6.011a3.492 3.492 0 002.82-1.077A3.488 3.488 0 0055.5 41c0-.966-.392-1.841-1.025-2.475a3.497 3.497 0 00-2.975-.99V31.5h-6.337c.217-.455.337-.963.337-1.5 0-.966-.392-1.841-1.025-2.475A3.489 3.489 0 0042 26.5c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 0038.5 30c0 .537.12 1.045.337 1.5H32.5v6.036a3.489 3.489 0 012.976.99A3.489 3.489 0 0136.499 41c0 .966-.392 1.841-1.025 2.475a3.489 3.489 0 01-2.976.99V50.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
        </g>
    </svg>
</template>
